module.exports = __webpack_public_path__ + "static/media/font-case.7878c710.svg";